import { GetPregenerated, GetPregeneratedParams } from "@/api/interfaces/inagami";
import { inagamiHttpClient } from "@/api/inagami-http-client";

export async function getPregenerated(params: { matchIds: string[] | number[] }): Promise<GetPregenerated> {
    // Beware: If multiple match ids are used and one of them has no result the whole response returns error code 204 (no content), for single id it is 404 (not found).
    // Not my cup of tea... I would prefer returning empty array (or array of found results only) instead but that's life.
    const queryParams: GetPregeneratedParams = { languageCode: "cz", matchIds: params.matchIds.map(String) };
    const response = await inagamiHttpClient.get("/api/getPregenerated", { params: queryParams });
    return response.data;
}
